import React from 'react';

import './movie-card.scss';

import { Link } from 'react-router-dom';

import Button from '../button/Button';

import tmdbApi, { category } from '../../api/tmdbApi';
import apiConfig from '../../api/apiConfig';
import { useSelector } from 'react-redux';
import { addBooks, removeBook, selectUser } from '../../features/user/userSlice';
import { useDispatch } from 'react-redux';
import { arrayRemove, arrayUnion, doc, updateDoc } from '@firebase/firestore';
import { db } from '../../firebase';
import { notify } from '../notify/Notify';

const MovieCard = props => {
    const user = useSelector(selectUser)
    const dispatch = useDispatch()
    let item  = props.item;
    
    const link = '/' + category[props.category] + '/' + item.id;
    if(user?.displayName&&user?.bookingList.find(ele=>ele.id===item.id)){
      item={...item,booked:true,category:props.category}
    }else{
      item = { ...item, booked: false, category: props.category };
    }

    const bg = apiConfig.w500Image(item.poster_path || item.backdrop_path);
    let timeOut;
     const setModalActive = async () => {
       const modal = document.querySelector(`.modal`);
        modal.classList.add("movie-modal");
       const videos = await tmdbApi.getVideos(category.movie, item.id);

       if (videos.results.length > 0) {
         const videSrc =
           "https://www.youtube.com/embed/" + videos.results[0].key +"?autoplay=1&loop=1";
         modal
           .querySelector(".modal__content > iframe")
           .setAttribute("src", videSrc);
       } else {
        return;
        //  modal.querySelector(".modal__content").innerHTML = "No trailer";
       }

       modal.classList.add("active");
     };
     const setModalClose =()=>{
         const modal = document.querySelector(`.modal`);
         modal.classList.remove("movie-modal");
          modal.querySelector(".modal__content > iframe").setAttribute("src","");
          modal.classList.remove("active")
         
     }
     const addOrRemoveBookmark=async(movie)=>{
       try {
         if(!user.uid){
           throw new Error("Login first")
         }
          const ref = doc(db, "users", user.uid);
          if (movie.booked) {
            movie.booked = false;

            dispatch(removeBook(movie));
            await updateDoc(ref, {
              bookingList: arrayRemove(movie),
            });

            return;
          }
          movie.booked = true;
          dispatch(addBooks(movie));
          await updateDoc(ref, {
            bookingList: arrayUnion(movie),
          });
       
         
       } catch (err) {
         notify(err.message)
       }
      
        
     }

    return (
      <div>
        <span onClick={() => addOrRemoveBookmark(item)} className="bookmark">
          <i
            type="solid"
            className={`bx bx${
              item.booked ? "s" : ""
            }-bookmark-alt bx-tada-hover`}
          ></i>
        </span>
        <Link to={link}>
          <div
            onMouseEnter={(e) => {
              timeOut = setTimeout(() => setModalActive(), 3000);
            }}
            onMouseLeave={() => {
              clearTimeout(timeOut);
              setModalClose();
            }}
            onClick={() => {
              clearTimeout(timeOut);
              setModalClose();
            }}
            className="movie-card"
            style={{ backgroundImage: `url(${bg})` }}
          >
            <Button>
              <i className="bx bx-play"></i>
            </Button>
          </div>
          <h3>{item.title || item.name}</h3>
        </Link>
      </div>
    );
}




export default MovieCard;
